import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataXx from './phonics/phonics_data_xx';

function PhonicsXx() {
  return <PhonicsAtoZ letterData={letterDataXx} />;
}

export default PhonicsXx;
